<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">[受講者情報]画面の入り方</li>
                        <li @click="scrollToElement('vn-2')">受講者検索</li>
                        <li @click="scrollToElement('vn-3')">受講者成績のエクスポート</li>
                        <li @click="scrollToElement('vn-4')">コース一覧</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1.[受講者情報]画面への入り方</h1>
                </div>
                <div><img src="/static\images\ja\newManual\manageStudentManual-1.png" alt="" /></div>
                <div>
                    <p>① [ログインユーザアイコン]をクリックして、管理者用の管理メニューを開きます。</p>
                    <p>② [受講者情報]をクリックすると、管理対象である受講者を管理する[受講者情報]画面が表示されます。</p>
                </div>
                <div id="vn-2">
                    <h1>2.受講者検索</h1>
                </div>
                <div>
                    <p>
                        <b><i>2.1.受講者氏名で検索</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageStudentManual-2.png" alt="" /></div>
                <div>
                    <p>① 受講者の[名前]タブをクリックします。</p>
                    <p>② 検索したい受講者の名前を入力してください。</p>
                </div>
                <div>
                    <p>
                        <b><i>2.2.メールアドレスで検索</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageStudentManual-3.png" alt="" /></div>
                <div>
                    <p>① 受講者の[メール]タブをクリックします。</p>
                    <p>② 検索したい受講者のメールアドレスを入力してください。</p>
                </div>
                <div id="vn-3">
                    <h1>3.受講者成績のエクスポート</h1>
                </div>
                <div><img src="/static\images\ja\newManual\manageStudentManual-4.png" alt="" /></div>
                <div>
                    <p>[成績出力]ボタンをクリックし、受講者の成績情報のExcelファイルとしてエクスポートされます。</p>
                </div>
                <div id="vn-4">
                    <h1>4.コース一覧</h1>
                </div>
                <div>
                    <p>
                        <b><i>4.1.コースの検索</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageStudentManual-5.png" alt="" /></div>
                <div>
                    <p>① 検索したいコースのタイトルを入力してください。</p>
                    <p>② 検索したいコースのカテゴリを選択してください。</p>
                    <p>③ スイッチコントロールをクリックすることで、検索対象の学習状態を設定してください。</p>
                </div>
                <div>
                    <p>
                        <b><i>4.2.コースの詳細</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageStudentManual-6.png" alt="" /></div>
                <div>
                    <p>コースの詳細を表示するには、コースをクリックしてください。</p>
                </div>
                <div>
                    <p>
                        <b><i>4.3.小テストの回答状況</i></b>
                    </p>
                </div>
                <div><img src="/static\images\ja\newManual\manageStudentManual-7.png" alt="" /></div>
                <div>
                    <p>小テストの得点率をクリックし、小テストの回答内容を確認することができます。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/manageStudent_manual.vue